export const opensKeyboard = (target) => (target instanceof HTMLInputElement &&
    ![
        'button',
        'checkbox',
        'color',
        'file',
        'image',
        'radio',
        'range',
        'reset',
        'submit',
    ].includes(target.type)) ||
    target instanceof HTMLTextAreaElement ||
    (target instanceof HTMLElement && target.isContentEditable);
//# sourceMappingURL=opensKeyboard.js.map